import { Link } from 'react-router-dom';

const footerLinks = {
  content: [
    { label: '日韩国产在线', to: '/category?tab=guochan' },
    { label: '日韩激情在线', to: '/category?tab=jiqing' },
    { label: '日韩精品在线', to: '/category?tab=jingpin' },
    { label: '日韩久久在线', to: '/category?tab=jiujiu' },
    { label: '日韩高清在线', to: '/category?tab=gaoqing' },
  ],
  about: [
    { label: '关于我们', to: '/about' },
    { label: '品牌介绍', to: '/about#intro' },
    { label: '用户口碑', to: '/about#reviews' },
    { label: '联系我们', to: '/about#contact' },
  ],
  support: [
    { label: '常见问题', to: '/#faq' },
    { label: '观看指南', to: '/#faq' },
    { label: '更新日志', to: '/#faq' },
  ],
};

const socialLinks = [
  { icon: 'ri-weibo-line', label: '微博', href: '#' },
  { icon: 'ri-wechat-line', label: '微信', href: '#' },
  { icon: 'ri-bilibili-line', label: 'B站', href: '#' },
  { icon: 'ri-tiktok-line', label: '抖音', href: '#' },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="font-heading text-lg font-bold text-background-50 mb-4">日韩在线</h3>
            <p className="text-sm leading-relaxed text-background-400">
              汇聚日韩最全影视资源，日剧、韩剧、动漫、综艺一站式观看。日韩国产在线与日韩激情在线高清一区二区，日韩精品在线久久免费观看全集。
            </p>
            <div className="flex items-center gap-3 mt-4">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  rel="nofollow"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">内容分类</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.content.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">关于</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">帮助</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <Link
              to="/category"
              className="inline-block mt-4 bg-accent-500 text-background-50 dark:text-foreground-950 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors duration-200 cursor-pointer"
            >
              开始探索
            </Link>
          </div>
        </div>

        <div className="pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2025 日韩在线 rihanzaixian.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">使用条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}